import React from 'react';
import Dropdown from '../common/Dropdown';
import IconButton from '../common/IconButton';

interface Tab {
  label: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  selectedTab: number;
  setSelectedTab: (index: number) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  selectedTab,
  setSelectedTab,
}) => {
  return (
    <div className="flex items-center gap-2">
      <Dropdown
        label={
          <IconButton
            src="/assets/svgs/fi_filter.svg"
            className="size-50"
            tooltip="Filter"
          />
        }
        side="right"
      >
        <ul className="bg-white w-[200px] shadow-[0_2px_16px_2px_rgba(0,0,0,0.08)] rounded-3xl py-2 pt-0 pb-0">
          {tabs.map((tab, index) => {
            const isFirst = index === 0;
            const isLast = index === tabs.length - 1;

            let paddingClasses = 'py-2 px-6';
            if (isFirst) {
              paddingClasses = 'pt-6 pb-2 px-6';
            } else if (isLast) {
              paddingClasses = 'pt-2 pb-6 px-6';
            }

            return (
              <li
                key={index}
                className={`text-[#292828] text-sm lg:text-base ${paddingClasses} border-b ${
                  selectedTab === index ? 'font-[600]' : 'font-[400]'
                } py-[8px] cursor-pointer  font-content whitespace-nowrap hover:bg-gray-200 ${isFirst ? 'hover:rounded-t-3xl' : ''}
                  ${isLast ? 'hover:rounded-b-3xl border-b-0' : ''}`}
                onClick={() => setSelectedTab(index)}
              >
                {tab.label}
              </li>
            );
          })}
        </ul>
      </Dropdown>
    </div>
  );
};

export default TabNavigation;
